export default function routing($stateProvider) {
    $stateProvider
        .state('template', {
            url: '/template',
            abstract: true
        })

        .state('template.index', {
            url: '',
            controller: 'TemplatesCtrl',
            controllerAs: 'index',
            template: require('../../../views/template/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:TEMPLATE:INDEX'
            }
        })

        .state('template.create', {
            url: '/create',
            controller: 'TemplateCreateCtrl',
            controllerAs: 'creator',
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CREATE',
                parent: 'template.index'
            }
        })

        .state('template.edit', {
            url: '/{id}/edit/',
            controller: 'TemplateEditCtrl',
            controllerAs: 'edit',
            template: require('../../../views/template/edit.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CREATE',
                parent: 'template.index'
            }
        })

        .state('template.order', {
            url: '/order',
            controller: 'OrderCtrl',
            controllerAs: 'order',
            template: require('../../../views/template/order.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:ORDER',
                parent: 'template.index'
            }
        })
}